import React from "react";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-black text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8 text-center md:text-left">
          {/* Company Info */}
          <div className="text-center md:text-left">
            <div className="flex items-center justify-center md:justify-start mb-6">
              <div className="text-xl font-semibold">
                <span className="text-white">LOVECCHIO</span>
                <span className="text-orange-500 ml-1">GROUP</span>
              </div>
            </div>
            <p className="text-gray-400 mb-4 text-center md:text-left">
              Partner strategico per soluzioni di telecomunicazione e connettività aziendale.
            </p>
            <p className="text-sm text-gray-500 text-center md:text-left">
              Oltre 10 anni di esperienza nel settore.
            </p>
          </div>
          
          {/* Services */}
          <div className="text-center md:text-left">
            <h3 className="text-lg font-semibold mb-4">Servizi</h3>
            <ul className="space-y-2 text-gray-400">
              <li><Link to="/servizio/office-smart" className="hover:text-orange-400 transition-colors">Office Smart</Link></li>
              <li><Link to="/servizio/office-plus" className="hover:text-orange-400 transition-colors">Office Plus e Maxi</Link></li>
              <li><Link to="/servizio/super-unlimited" className="hover:text-orange-400 transition-colors">Super Unlimited</Link></li>
              <li><Link to="/servizio/machine2machine" className="hover:text-orange-400 transition-colors">Machine2Machine</Link></li>
              <li><Link to="/dispositivi" className="hover:text-orange-400 transition-colors">Dispositivi</Link></li>
            </ul>
          </div>
          
          {/* Company */}
          <div className="text-center md:text-left">
            <h3 className="text-lg font-semibold mb-4">Azienda</h3>
            <ul className="space-y-2 text-gray-400">
              <li><Link to="/trova-agente" className="hover:text-orange-400 transition-colors">Chi siamo</Link></li>
              <li><Link to="/trova-agente" className="hover:text-orange-400 transition-colors">Team</Link></li>
              <li><a href="#" className="hover:text-orange-400 transition-colors">Partners</a></li>
              <li><Link to="/carriere" className="hover:text-orange-400 transition-colors">Carriere</Link></li>
            </ul>
          </div>
          
          {/* Contacts */}
          <div className="text-center md:text-left">
            <h3 className="text-lg font-semibold mb-4">Contatti</h3>
            <div className="space-y-3">
              <div className="flex items-center justify-center md:justify-start text-gray-400">
                <MapPin size={16} className="mr-2 text-orange-400" />
                <span className="text-sm">Via Fiesole 50, Lecce</span>
              </div>
              <div className="flex items-center justify-center md:justify-start text-gray-400">
                <Phone size={16} className="mr-2 text-orange-400" />
                <span className="text-sm">+39 333 1341439</span>
              </div>
              <div className="flex items-center justify-center md:justify-start text-gray-400">
                <Mail size={16} className="mr-2 text-orange-400" />
                <span className="text-sm">info@lovecchiogroup.it</span>
              </div>
              <div className="flex items-center justify-center md:justify-start text-gray-400">
                <Clock size={16} className="mr-2 text-orange-400" />
                <span className="text-sm">Lun-Ven 9:00-18:00</span>
              </div>
            </div>
          </div>
        </div>
        
        {/* Bottom bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-400 text-sm mb-4 md:mb-0">
            © 2024 Lovecchio Group. Tutti i diritti riservati.
          </div>
          <div className="flex space-x-6 text-sm text-gray-400">
            <a href="#" className="hover:text-orange-400 transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-orange-400 transition-colors">Cookie Policy</a>
            <a href="#" className="hover:text-orange-400 transition-colors">Termini di Servizio</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;